/*@flow*/
/** @jsx jsx */
import { css, jsx, Global } from '@emotion/core';
import { createRef, useEffect, useState } from 'react';
import Folio from 'lib/folio';
import compose from 'lib/compose';
import Left2Container from 'comps/Left2/Container';
import useContextState from 'comps/Left2/useContextState';
import useCommands from 'comps/Left2/useCommands';
import { Component as Left2 } from 'comps/Left2';
import { Container as AreaContainer } from 'comps/City/AreaTools';
import { hocShell } from 'comps/ResourceBuilder/Shell';
import useMap from './useMap';
import useProjects from './useProjects';
import Blank from 'lib/Blank';
import waitTill from 'lib/waitTill';
import getQueryKey from 'lib/getQueryKey';
import PATHS from 'const/paths';
import isSmallScreen from 'lib/isSmallScreen';
import truthy from 'lib/truthy';
import { Sidebar } from './Sidebar';
import { useDomSync } from './useDomSync';
import { MapContainer } from './MapContainer';
import { InnerDiv } from './InnerDiv';
import { Canvas } from './Canvas';
import { ResourceModalContainer } from './ResourceModalContainer';

const City = () => {
  const ToolbarContainer = Left2Container;
  const Toolbar = Left2;

  return (
    <ToolbarContainer>
      <Global
        styles={css(`
      .pages.map {
        article#site {
          height: calc(100% - 100px);
          min-height: initial;
          & > div {
            height: 100%;
          }
        }

        #footer {
          display: none;
        }

        .leaflet-container,
        .map-container {
          background: #fff center 45% no-repeat;
        }

        .project-popup-list button {
          @media (max-width: 768px) {
            font-size: 1.4em;
          }
        }

        .leaflet-top.leaflet-right {
          position: relative;
          .search-control {
            position: absolute;
            width: 340px;
            right: 40px;
            top: 0px;
            height: 0px;
            @media (max-width: 768px) {
              width: 215px;
            }
          }
        }
      }
      `)}
      />
      <AreaContainer>
        <InnerDiv>
          <ResourceModalContainer />
          <MapContainer>
            <Toolbar />
            <Canvas />
            <Sidebar />
          </MapContainer>
        </InnerDiv>
      </AreaContainer>
    </ToolbarContainer>
  );
};

export default hocShell(City);
